import { useEffect, useRef } from 'react';
import { useAuth } from '../../auth/useAuth';
import { bootstrapPayzheBtpBridge } from './payzheBtpMobileBootstrap';
import { isPayzheBtpEligible } from './mobilePlatform';

/** Wires payzhe BTP bridge bootstrap once per authenticated Android session. */
export function PayzheBtpBootstrapEffect(): null {
  const { isAuthenticated } = useAuth();
  const startedRef = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || !isPayzheBtpEligible() || startedRef.current) {
      return;
    }
    startedRef.current = true;
    void bootstrapPayzheBtpBridge({ wakeApp: 'auto', connectPrinter: true });
  }, [isAuthenticated]);

  return null;
}
